import { useLiveQuery } from 'dexie-react-hooks';
import { CATEGORIAS_SUGERIDAS } from '@abastece/shared';
import { db } from '../db/dexie.js';
import { useT } from '../i18n/index.js';
import { etiquetaCategoriaProducto } from '../i18n/dominio.js';
import { ElegirEscribiendo } from './ElegirEscribiendo.js';

/**
 * A product's category, picked by typing (2026-10-12, as the owner asked of the supplier: «if you
 * click on the field it should show all … in alphabetical order»). It was a field with the suggested
 * categories for the browser's hints, which offered only those starting like what it already said —
 * «Abarrotes», with «Abarrotes» in it — and never a category of the shop's own. Tapped, it lists
 * every category, the suggested ones and every one the shop's products are filed under; typed into,
 * what matches; a name nobody has is a new category, kept as typed.
 *
 * The value stays the Spanish category the shop files under; an English screen shows the English for
 * the suggested ones. Choosing "Drinks" therefore still files under «Bebidas», rather than splitting
 * one shelf into two categories that happen to be written in different languages.
 */
export function CampoCategoria({ value, onChange }: { value: string; onChange: (categoria: string) => void }) {
  const t = useT();
  const usadas = useLiveQuery(async () => (await db.productos.toArray()).map((p) => p.categoria), [], [] as string[]);
  const opciones = [...new Set([...CATEGORIAS_SUGERIDAS, ...usadas].map((c) => c?.trim()).filter((c): c is string => Boolean(c)))].map(
    (c) => ({ id: c, nombre: etiquetaCategoriaProducto(c) }),
  );
  return (
    <ElegirEscribiendo
      etiqueta={t('producto.categoria')}
      placeholder={t('producto.categoriaEscriba')}
      opciones={opciones}
      value={value}
      onChange={onChange}
      libre
      // As long as a product's category is (`producto.creado`).
      maxLength={60}
      nuevo={{
        etiqueta: (escrito) => (escrito ? t('producto.categoriaNueva', { nombre: escrito }) : ''),
        onNuevo: (escrito) => onChange(escrito.replace(/\s+/g, ' ')),
      }}
      datos="categoria"
    />
  );
}
